import { api } from '@/shared/api/axios';
import type { Project, ProjectsFilters, UpdateProjectPayload } from '@/features/projects/types';
import type { MutationResponse } from './contracts';
import { projectPaths } from './paths';

export interface ProjectCreateRequest {
  name: string;
  department: string;
  description?: string;
  client?: string;
  status?: Project['status'];
  priority?: Project['priority'];
  start_date?: string | null;
  end_date?: string | null;
  deadline?: string | null;
  assigned_to?: string[];
  referral_name?: string;
  referral_contact?: string;
  referral_amount?: number;
  project_value?: number;
  attachments?: string[];
  reference_urls?: string[];
}

export const projectsApi = {
  async list(filters: ProjectsFilters = {}): Promise<Project[]> {
    const { data } = await api.get<{ projects: Project[] }>(projectPaths.list(filters));
    return data.projects ?? [];
  },
  async create(payload: ProjectCreateRequest): Promise<MutationResponse & { id: string }> {
    return (await api.post<MutationResponse & { id: string }>(projectPaths.create, payload)).data;
  },
  async update(id: string, payload: UpdateProjectPayload): Promise<MutationResponse> {
    return (await api.patch<MutationResponse>(projectPaths.update(id), payload)).data;
  },
  async remove(id: string): Promise<MutationResponse> {
    return (await api.delete<MutationResponse>(projectPaths.remove(id))).data;
  },
};
